import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';

export interface ImageLightboxData {
  imageUrl: SafeUrl | string;
  title: string;
  downloadFileName?: string;
}

@Component({
  selector: 'app-image-lightbox-dialog',
  templateUrl: './image-lightbox-dialog.component.html',
  styleUrls: ['./image-lightbox-dialog.component.scss'],
  standalone: false
})
export class ImageLightboxDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageLightboxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageLightboxData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  async onDownload(): Promise<void> {
    try {
      const imageUrl = typeof this.data.imageUrl === 'string' 
        ? this.data.imageUrl 
        : (this.data.imageUrl as any).changingThisBreaksApplicationSecurity;

      // Fetch the image as a blob
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.data.downloadFileName || `${this.data.title.replace(' ', '-')}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback: open in new tab
      const imageUrl = typeof this.data.imageUrl === 'string' 
        ? this.data.imageUrl 
        : (this.data.imageUrl as any).changingThisBreaksApplicationSecurity;
      window.open(imageUrl, '_blank');
    }
  }
}
